import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: "wbo-entity-action",
    template: "<ng-content></ng-content>"
})
export class EntityActionComponent {
    @Input() title: string;
    @Output() click: EventEmitter<any> = new EventEmitter();

    clicked(): void {
        this.click.emit();
    }
}
